import React, { FC } from 'react';
import { Label } from '@src/components/Label';
import { Avatar } from '@src/components/Avatar';
import { getNameInitials } from '@src/util/getNameInitials';
import { Footer } from '../Footer';
import Message from './Message';
import { SendMessageProps } from './props';
import './styles.scss';

export const SendMessage: FC<SendMessageProps> = ({
  message,
  verifiedUser,
  onClose,
  modalOptions,
  onMessageSend,
  onMessageChange,
}) => {
  const { user } = verifiedUser;
  const { location, isRelocation, isRemote } = user.profile;

  return (
    <div className="verify-talent-message-modal">
      <div className="verify-talent-message-modal__header">
        <div>
          <div className="verify-talent-message-modal__avatar-container">
            <Avatar
              avatarColor={user.avatarColor || undefined}
              className="verify-talent-message-modal__avatar"
              initials={getNameInitials(user.name)}
            />
            <div className="verify-talent-message-modal__avatar-info">
              <h3>{user.name || ''}</h3>
              <p>{`${user.position || ''} • ${location.shortName}`}</p>
            </div>
          </div>
          <div className="verify-talent-message-modal__labels">
            {isRelocation && (
              <Label text="RELOCATION" type="invisible" wrapperClassName="verify-talent-message-modal__label" />
            )}

            {isRemote && <Label text="REMOTE" type="invisible" wrapperClassName="verify-talent-message-modal__label" />}
          </div>
        </div>
      </div>
      <div className="verify-talent-message-modal__content-wrapper">
        <h3 className="verify-talent-message-modal__title">Invite to an interview</h3>
        <div className="verify-talent-message-modal__message-and-template">
          <div className="verify-talent-message-modal__message-section">
            <Message defaultMessage={message} onMessageChange={onMessageChange} />
          </div>
        </div>
      </div>

      <Footer
        message={message}
        modalOptions={modalOptions}
        onButtonClick={onMessageSend}
        onClose={onClose}
        talent={verifiedUser}
      />
    </div>
  );
};
